export const HTMLBuilder = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="23" y="5" width="6" height="6" stroke="currentColor" stroke-width="2"/>
<rect x="3" y="5" width="6" height="6" stroke="currentColor" stroke-width="2"/>
<path d="M11 28V21H4" stroke="currentColor" stroke-width="2"/>
<path d="M2.5 29.5L11 21" stroke="currentColor" stroke-width="2"/>
<path d="M17 28V12C17 9.79086 18.7909 8 21 8H23" stroke="currentColor" stroke-width="2"/>
<path d="M9 8H23" stroke="currentColor" stroke-width="2"/>
</svg>`;
